import RequestForm from "../../../subComponent/RequestForm";
import Footer from "../../../subComponent/Footer";

const BeSpoke = () => {
    return (
        <>

            <div className="bg-white">
                <div className="row">
                    <div className=" col-12  background-setting bespoke-banner p-0">
                        <div className="bespoke-section">
                            <div className="inventory-backdrop p-0" >
                                <p className=" bespoke-text text-center text-white fs_30 poppins py-3 ">Design & Build Your OwnCustomized Database &Personalized Big Data</p>
                            </div>
                        </div>
                    </div>
                    <div className=" col-12 col-md-11 background-setting design-background mt-5 p-0">
                        <div className="inventory-backdrop p-0" >
                            <div class="line-before text-white fs_19">Bespoke Solution </div>
                            <div className="container">
                                <div className="py-5 px-3 px-md-5">
                                    <p className="sales-text text-white fs_32 poppins m-0 pb-4 ">Design, Build & Test</p>
                                    <p className="sales-descrption text-white poppins m-0 ls_2 fs_19 pb-4 ">If You Can’t Find What You Need, Why Not Build It? And We’ll Build it At a Reasonable Cost.</p>

                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-md-1">
                    </div>
                    <div className="col-12 col-md-10 background-setting test-background  p-0">
                        <div className="inventory-backdrop test-backdrop" >
                            <div className="container">
                                <div className="py-5 px-3 px-md-5">
                                    <p className="sales-descrption text-white  poppins m-0 fs_20  pb-3">Our founder, with a Mechanical Engineering background, has incorporated the designing, building and testing methodology from an engineering process into the problem solving process. Thus, allowing our clients to benefit from the design effectiveness and cost efficiency.</p>
                                    <p className="sales-descrption text-white  poppins m-0 fs_20  pb-3">When projects are done correctly, we spend more time planning and designing (where the value of our work is) compared to building. And because we have tested the design in a simulated environment, the testing phase is usually shorter.</p>

                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-md-2"></div>
                    <div className="col-12 col-md-1">
                    </div>
                    <div className=" col-12 col-md-11 background-setting imagination-background mt-5 p-0">
                        <div className="inventory-backdrop p-0" >
                            <div class="line-before line-after text-white fs_19">Bespoke Solution </div>
                            <div className="container">
                                <div className="py-5 px-3 px-md-5">
                                    <p className="  text-end text-white fs_32 poppins m-0 pb-5 ">Design, Customized & Implement</p>
                                    <p className=" text-end text-white poppins m-0 ls_2 fs_19 pb-5 ">You Imagine, We Build</p>

                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-md-2"></div>
                    <div className="col-12 col-md-10 background-setting customized-background p-0">
                        <div className="inventory-backdrop customized-backdrop" >
                            <div className="container">
                                <div className="py-5 px-3 px-md-5">
                                    <p className=" imagination-text d-flex gap-4 sales-descrption text-white  poppins m-0 fs_20  pb-3 pb-md-">Highly Customizable ERP System</p>
                                    <p className=" imagination-text d-flex gap-4  sales-descrption text-white  poppins m-0 fs_20  pb-3">Built on IoT concepts</p>
                                    <p className=" imagination-text d-flex gap-4  sales-descrption text-white  poppins m-0 fs_20  pb-3">Affordable & User Friendly</p>
                                    <p className=" imagination-text d-flex gap-4  sales-descrption text-white  poppins m-0 fs_20  pb-3">Fits into Your Existing Processes</p>
                                    <p className=" imagination-text d-flex gap-4 sales-descrption text-white  poppins m-0 fs_20  pb-3">Touch Screen Terminals, Mobile Computers, Androids and more</p>
                                    <p className=" text-white poppins m-0 ls_2 fs_20 py-2 py-md-5 ">Note: The mobile app was designed for foreign workers (who are not proficient in English) in a factory in Malaysia. Big buttons, numbers and colours were used to improve the user experiences.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className=" col-12 col-md-11 background-setting optimize-background mt-5 p-0">
                        <div className="inventory-backdrop p-0" >
                            <div class="line-before text-white fs_19">Bespoke Solution </div>
                            <div className="container">
                                <div className="py-5 px-3 px-md-5">
                                    <p className="sales-text text-white fs_32 poppins m-0 pb-4 ">Design, Build & Test</p>
                                    <p className="sales-descrption text-white poppins m-0 ls_2 fs_19 pb-4 ">If You Can’t Find What You Need, Why Not Build It? And We’ll Build it At a Reasonable Cost.</p>

                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-md-1">
                    </div>

                    <div className="col-12 col-md-10 background-setting optimize-banner-background p-0">
                        <div className="inventory-backdrop customized-backdrop" >
                            <div className="container">
                                <div className="py-5 px-3 px-md-5">
                                    <p className=" text-white poppins m-0 ls_2 fs_20 py-2 py-md-5 ">Designing a new or existing system means there’s an opportunity optimize your operations even further because the new system can fit in perfectly to your business. Hence, for each design, we will:</p>
                                    <p className=" imagination-text d-flex gap-4 sales-descrption text-white  poppins m-0 fs_20  pb-3 pb-md-">Review your business process</p>
                                    <p className=" imagination-text d-flex gap-4  sales-descrption text-white  poppins m-0 fs_20  pb-3">Evaluate the usefulness of the process</p>
                                    <p className=" imagination-text d-flex gap-4  sales-descrption text-white  poppins m-0 fs_20  pb-3">Challenge the controls of the process</p>
                                    <p className=" imagination-text d-flex gap-4  sales-descrption text-white  poppins m-0 fs_20  pb-3">Fits into Your Existing Processes</p>
                                    <p className=" imagination-text d-flex gap-4 sales-descrption text-white  poppins m-0 fs_20  pb-3">Evaluate alternatives based on latest available technology</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-md-2"></div>
                    <div className="col-12 col-md-1">
                    </div>
                    <div className=" col-12 col-md-11 background-setting data-analytics-background mt-5 p-0">
                        <div className="inventory-backdrop p-0" >
                            <div class="line-before line-after text-white fs_19">Bespoke Solution </div>
                            <div className="container">
                                <div className="py-5 px-3 px-md-5">
                                    <p className=" text-end text-white fs_32 poppins m-0 pb-5 ">Design, Customized & Implement</p>
                                    <p className=" text-end text-white poppins m-0 ls_2 fs_19 pb-5 ">You Imagine, We Build</p>

                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-md-2"></div>
                    <div className="col-12 col-md-10 background-setting review-background sp-0 mb-5">
                        <div className="inventory-backdrop customized-backdrop" >
                            <div className="container">
                                <div className="py-5 px-3 px-md-5">
                                    <p className=" text-white poppins m-0 ls_2 fs_20 py-2 py-md-5 ">Reading this now means you are probably open to change and may be open to review your existing process, right? I’m sure you are. Hence, for each customer, we need to:</p>
                                    <p className=" imagination-text d-flex gap-4 sales-descrption text-white  poppins m-0 fs_20  pb-3 pb-md-">Review your business process</p>
                                    <p className=" imagination-text d-flex gap-4  sales-descrption text-white  poppins m-0 fs_20  pb-3">Evaluate the usefulness of the process</p>
                                    <p className=" imagination-text d-flex gap-4  sales-descrption text-white  poppins m-0 fs_20  pb-3">Challenge the controls of the process</p>
                                    <p className=" imagination-text d-flex gap-4 sales-descrption text-white  poppins m-0 fs_20  pb-3">Evaluate alternatives based on latest available technology</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <RequestForm />
                </div>
                <div className="background-setting be-spoke-footer py-5">
                    <Footer />
                </div>
            </div>
        </>
    );
}

export default BeSpoke;




